import Repository from '@/api/core'
const baseURL = process.env.VUE_APP_API_CROSS_VENDOR + '/action-wrapper'

const callAction = params => {
  return Repository(baseURL).create(params)
}

export default {callAction}
